export const CDN_HOST_SUFFIX = '.cdn.modulify.website'

export const isOptimizableImage = (src: string): boolean => {
    if (src.startsWith('/') && !src.startsWith('//')) return true

    try {
        const url = new URL(src)

        return url.protocol === 'https:' && url.hostname.endsWith(CDN_HOST_SUFFIX)
    }
    catch {
        return false
    }
}
